// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropzone .dz-preview .dz-error-message {\n  top: 150px !important;\n}", ""]);
// Exports
module.exports = exports;
